module.exports = __webpack_public_path__ + "img/completado_a.7d25382c.png";